<template>
  <div class='container'>

    <div class='vtop'>
      <!-- 用户信息+进度 -->
      <div class="user-container" v-if="init">
        <div class="cur-progress"> word:{{ curNum + 1 }}/{{ totalNum }}</div>
        <div class="uname">{{ userInfo.username }}</div>
        <img class="touxiang" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/cp_touxiang@2x.png" alt="">
      </div>

      <!-- 当前题目 + 倒计时 -->
      <div class='alart-v' v-if="init">
        <div class="current-num">第{{ curNum + 1 }}题：</div>
        <div class='showSec'>{{ gameSecond }}s</div>
      </div>
    </div>

    <!-- 单词 -->
    <div class='audio-v' @click='playOne' v-if="wordCur.subject">
      <div class='audio-text'>{{ wordCur.subject.title }}</div>
    </div>

    <!-- 选项 -->
    <!-- style="background:{{index == selectedIndex?'#DFFFEF':'#FFF'}}" -->
    <div class='option-container' v-if="init">
      <div class="user_options">
        <div :class="[(index == selectedIndex)?'selectedoption':'option']"
             v-for="(item,index) in wordCur.options"
             @click='clickOption(item)'>
          <div class='vtext'>{{ item.title }}</div>
        </div>
      </div>
      <!-- 不认识 -->
      <div :class="[(isunknowClik == 1)?'selectedoption':'option']" @click="clickUnknown">
        <div class='vtext'>不认识</div>
      </div>
    </div>


    <div class="timeout_layer" v-if="show_report_page">
      <div class="timeout_layer_content">
        <div class="content_bd">
          <div class="timeout_image">
            <img src="https://777-static.oss-cn-beijing.aliyuncs.com/word_pk_2023_06/jieshu/jieshu_naozhong.png" alt="">
          </div>
          <div class="timeout_desc">时间结束，请查看结果</div>
          <div class="timeout_button" @click="toResultPage">去查看</div>
        </div>
      </div>
    </div>
    <div class="back_btn" @click="backRoute">
      <img src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/2023_06_back.png" alt="">
    </div>
  </div>
</template>
<style lang="less" scoped>

.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-size: 100% 100%;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/bg_cp.png");
  height: 100%;
  width: 100%;
}

.timeout_layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;

  .timeout_layer_content {
    height: 430px;
    width: 400px;
    background-color: #fff;
    border-radius: 10px;

    .content_bd {
      padding: 1rem;
      height: 100%;
      display: flex;
      text-align: center;
      flex-direction: column;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: space-around;

      .timeout_image img {
        width: 260px;
      }

      .timeout_desc {
        font-size: 16px;
        color: rgba(88, 59, 0, 1);
      }

      .timeout_button {
        cursor: pointer;
        font-size: 18px;
        display: block;
        margin: 0 auto;
        width: 300px;
        height: 40px;
        line-height: 40px;
        background: #0AC684;
        color: #fff;
        border-radius: 8px;
      }
    }
  }
}

/* 顶部容器 */

.user_options {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .option {
    width: 286px;
    overflow: hidden;
    margin-left: 10px;
    margin-bottom: 10px;
    cursor: pointer;
  }
}

.vtop {
  width: 100%;
  height: 24%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.user-container {
  width: 500px;
  height: 107px;
  position: relative;
  margin-top: 22px;
}

.touxiang {
  width: 102px;
  height: 102px;
  position: absolute;
  left: 0;
  top: 0;
}

.cur-progress {
  width: 358px;
  height: 42.7px;
  line-height: 42.7px;
  background-size: 358px 44.8px;
  background-repeat: no-repeat;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cp_jindu@2x.png");
  font-size: 23px;
  font-weight: bold;
  color: #192B03;
  padding-left: 33.6px;
  position: absolute;
  left: 71.4px;
  top: 10px;
}


.back_btn{
  position: fixed;
  left: 3rem;
  bottom: 2rem;
}

.uname {
  width: 179px;
  height: 33.6px;
  background-size: 179px 33.6px;
  background-repeat: no-repeat;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cp_jindu_bg2@2x.png");
  font-size: 20px;
  color: #411501;
  line-height: 33.6px;
  text-align: left;
  letter-spacing: 4px;
  padding-left: 33.6px;
  position: absolute;
  left: 71.4px;
  top: 51.8px;
}

/* 当前题目+倒计时 */
.alart-v {
  width: 212px;
  height: 51px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-size: 212px 51px;
  background-repeat: no-repeat;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/cp_xjd_bg@2x.png");
  margin-top: 12px;
}

.current-num {
  font-size: 18px;
  font-weight: bold;
  color: #056935;
}

/* 秒数 */
.showSec {
  font-size: 18px;
  font-weight: bold;
  color: #056935;
  margin-left: 10px;
}

/* 当前测试的单词 */
.audio-v {
  width: 390px;
  height: 95.2px;
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-size: 390px 95.2px;
  background-repeat: no-repeat;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cp_timu@2x.png");
}


.audio-text {
  height: 40.6px;
  line-height: 40.6px;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  color: #192B03;
}

/* 选项容器 */
.option-container {
  width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 24px;
}

/* 选项 */
.option, .selectedoption {
  width: 288.4px;
  height: 58.8px;
  line-height: 58.8px;
  align-items: center;
  background: rgba(239, 251, 244, 1);
  border-radius: 30px;
  margin-top: 20px;
  font-size: 32px;
  color: #333333;
  display: flex;
  flex-direction: column;
}

.selectedoption {
  background-size: 288.4px 58.8px;
  background-repeat: no-repeat;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/btn_cp_xz_xz@2x.png");
}

/* 选项的文字样式 */
.vtext {
  font-size: 23px;
  color: #333333;
}
</style>
<script>
import { mapState, mapMutations } from 'vuex'
import { getAssessDetail, test_online_submit } from '../../services'

export default {
  name: 'word_competition_test',
  components: {},
  data () {
    return {
      submit_loading:false,
      init: 0,
      runStatus: 'begin',
      selectedmp3: 'https://777-wx-res.oss-cn-beijing.aliyuncs.com/word-test/MP3/selectsucc.mp3',
      innerAudioContext: new Audio(),
      timer: '',
      timeLimitTimer: null,
      id: '', //测评id
      totalTime: 15, //每题总的答题时间15s
      gameSecond: 15, //当前用时
      totalNum: 0, //总单词数
      listDatas: [], //总的测试词数据
      curNum: 0, //当前第几题
      wordCur: {}, //当前单词
      selectedIndex: -1, //当前选择的选项下标
      canClick: 0, //选项是否可点击
      ishide: 1, //界面是否黑屏
      score: 0, //单词分数
      knowWordList: [],
      noKnowWordList: [],
      answerDataList: [],
      userName: '智学树',
      test_last_time: false,
      show_report_page: false,
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  created () {
    this.id = this.$route.query.id
    getAssessDetail({
      id: this.id,
    }).then((res) => {
      this.init = 1
      this.runStatus = 'running'
      this.innerAudioContext.autoplay = false
      this.innerAudioContext.loop = false
      this.listDatas = res.data.list
      this.test_last_time = res.data.test.test_last_time
      this.curNum = 0
      this.wordCur = res.data.list[0]
      this.totalNum = res.data.list.length
      this.totalTime = res.data.config.test_limit_time
      this.gameSecond = res.data.config.test_limit_time
      //开始倒计时
      this.daojishi()
      if (this.test_last_time) {
        this.timeLimit()
      }
      this.playMp3(this.wordCur.subject.voice_url)
    })
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.timeLimitTimer) {
      clearInterval(this.timeLimitTimer)
    }
    if(this.submit_loading===false){
      this.submitWords();
    }
  },
  methods: {
    backRoute:function () {
      this.$router.push({
        path: '/word_competition',
      })
    },
    toResultPage: function () {
      this.$router.replace({
        path: '/word_competition_result',
        query: {
          id: this.id,
        }
      })
    },
    timeLimit: function () {
      this.timeLimitTimer = setInterval(() => {
        if (this.test_last_time) {
          console.log(this.test_last_time, Math.round(+new Date / 1000))
          if (this.test_last_time <= Math.round(+new Date / 1000)) {
            this.show_report_page = true
            this.submitWords()
          }
        }
      }, 1000)
    },
    /**
     * 倒计时
     */
    daojishi: function () {
      this.timer = setInterval(() => {
        let num = parseInt(this.gameSecond) - 1
        if (this.gameSecond <= 0) {
          return
        }
        this.gameSecond = num
        if (parseInt(this.gameSecond) <= 0) {
          this.answerAndJudge(false)
        }
      }, 1000)
    },

    playOne: function () {
      let voiceUrl = this.wordCur.subject.voice_url
      this.playMp3(voiceUrl)
    },

    //播放音频
    playMp3: function (url) {
      if (url) {
        this.innerAudioContext.src = url
        this.innerAudioContext.play()
      }
    },

    /**
     * 点击每个选项
     */
    clickOption: function (item) {
      if (this.runStatus !== 'running') {
        return
      }
      if (this.canClick === 1) {
        return
      }
      this.canClick = 1
      this.playMp3(this.selectedmp3)
      this.selectedIndex = -1;
      if (this.curNum >= this.listDatas.length) {
        console.log('最后一题选完选项，提交')
      } else {
        setTimeout(() => {
          this.answerAndJudge(item.is_right)
        }, 500)
      }

    },

    /**
     * 点击不认识
     */
    clickUnknown: function (e) {
      this.selectedIndex = -1
      this.isunknowClik = 1
      this.playMp3(this.selectedmp3)
      setTimeout(() => {
        this.answerAndJudge(false)
      }, 500)
    },

    /**
     * 答题并判断
     */
    answerAndJudge: function (isright) {
      let levelSize = this.listDatas.length
      let curNum = this.curNum
      let answerDataList = this.answerDataList
      if (answerDataList.length >= levelSize) {
        return
      }
      let currentId = this.wordCur.subject.word_id
      let answerObj = {}
      answerObj.id = currentId
      answerObj.is_right = isright
      answerObj.push_time = Math.round((+new Date()) / 1000)

      answerDataList.push(answerObj)

      if (!isright) {
        //如果答错了
        console.log('答错')
        this.noKnowWordList.push(currentId)
      } else {
        //选对
        console.log('答对')
        this.knowWordList.push(currentId)
      }
      if (curNum < levelSize - 1) {
        this.curNum = curNum + 1
        //下一题
        this.playNext()

      } else if (curNum >= levelSize - 1) {
        //单词测试结束，计算成绩
        this.submitWords()
      }
    },

    //单词下一题
    playNext: function () {
      let curNum = this.curNum
      this.wordCur = this.listDatas[curNum]
      this.selectedIndex = -1
      this.isunknowClik = 0
      this.gameSecond = this.totalTime
      this.canClick = 0
      this.playMp3(this.wordCur.subject.voice_url)
    },

    //提交单词检查记录
    submitWords: function () {
      this.submit_loading=true;
      this.runStatus = 'end'
      if (this.timer) {
        clearInterval(this.timer)
      }
      if (this.timeLimitTimer) {
        clearInterval(this.timeLimitTimer)
      }
      let canString = this.knowWordList.join(',')
      let can_notString = this.noKnowWordList.join(',')
      if (!this.answerDataList.length) {
        return
      }
      let answerStr = JSON.stringify(this.answerDataList)
      this.submitAssess({
        id: this.id,
        can: canString,
        can_not: can_notString,
        test_records: answerStr,
      })
    },
    submitAssess: function (data) {
      test_online_submit(data).then((res) => {
        if(this.listDatas.length===this.answerDataList.length){
          this.answerDataList=[];
          this.toResultPage();
        }
      })
    },
  }
}
</script>
